function initSignupPriceFormatter() {
    const target = document.getElementById('signupform');

    if (!target) {
        return;
    }

    const observer = new MutationObserver(() => {
        const priceElement = document.querySelector('.planorama_activity_price .price');
        if (priceElement && !priceElement.dataset.formatted) {
            const price = parseInt(priceElement.textContent, 10);
            if (!isNaN(price)) {
                priceElement.textContent = price.toLocaleString('da-DK');
                priceElement.dataset.formatted = 'true';
            }
        }
    });

    observer.observe(target, { childList: true, subtree: true });
}

export default initSignupPriceFormatter;
